import AudiencePage from '@/components/marketing/technology/AudiencePage'
import ApiExplorer from '@/components/marketing/technology/ApiExplorer'
import type { TechnologyAudienceProps } from '@/types/technology'

/* /technology/api — the platforms & developers audience page.
 *
 * Its one visual is the endpoint explorer, carrying REAL paths and response
 * shapes: the page's claim is that the reference is public and readable before
 * anyone talks to us, so it shows it rather than asking to be trusted.
 */
export default function Api(props: TechnologyAudienceProps) {
  return <AudiencePage {...props} media={<ApiExplorer />} />
}
